import { ISystemParameterService } from "../../service/systemparameter/SystemParameterService";

export default class GetSystemParametersInteractor {
  private systemParameterService: ISystemParameterService;

  constructor(systemParameterService) {
    this.systemParameterService = systemParameterService;
  }

  async execute() {
    return this.systemParameterService.getSystemParameters();
  }
}
